import { createContext } from 'react'

export const DocFlowMappingContext = createContext()
